import { ICON_COLOR } from '@zep-us/zus/tokens';
import { CaretDownIcon } from '@/icons';
import { cn } from '@/utils/tailwind.util';

/**
 * 국가 코드 표시 컴포넌트
 * 현재는 한국만 지원하므로 국기 + 아이콘만 표시 (드롭다운 없음)
 * TODO: 다국가 지원 시 드롭다운 추가
 */
export const CountryCodeSelector = ({
  className
}: {
  className?: string;
}) => {
  return <div className={cn('flex items-center rounded-tl-sm rounded-bl-sm', className)} data-sentry-component="CountryCodeSelector" data-sentry-source-file="CountryCodeSelector.tsx">
      <div className="flex items-center gap-3xs px-xs">
        <img src={'/assets/korea_flag.png'} alt="Korea Flag" className="w-[24px] shrink-0 object-contain" />
        <CaretDownIcon size="xs" fill={ICON_COLOR.neutral} data-sentry-element="CaretDownIcon" data-sentry-source-file="CountryCodeSelector.tsx" />
      </div>
    </div>;
};